export default "__VITE_ASSET__DuPR8Hc$__"